<template>
  <basic-input-modal
    @selectedElement="propagateChange"
    :byDefault="getData()"
    :student="student"
    :title="title"
    ref="input"
    :options="items"/>
</template>
<script>
import BasicInputModal from './BasicInputModal.vue'
import {componentValues, getDataByValue} from '@/utils/componentsValue'

export default {
  components: { BasicInputModal },
  created: function () {
    if (this.initialValue) this.state = this.initialValue
  },
  props: {
    initialValue: String,
    title: {
      type: String,
      default: () => 'Yogurt o Fruta'
    },
    student: String
  },
  data: () => ({
    enabled: false,
    state: 'fruta',
    items: componentValues.fruitOrYogurt
  }),
  methods: {
    getData: function () {
      return getDataByValue(this.items, this.state)
    },
    setValue: function (value) {
      this.state = value
      this.$refs.input.setValue(this.getData())
    },
    setEnable: function (value) {
      this.enabled = value
      this.$refs.input.setEnable(value)
    },
    propagateChange: function ({item}) {
      this.state = item.value
      this.$emit('updatedElement',
        { value: this.state }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryElements/FuitOrYogurt.vue